import React from 'react'

import { Card, Row, Span, CollapseColumn } from 'components'
import { COLORS, SPACING, FONTS, TYPOGRAPHY } from 'utils'

import TableSalaryReport from './TableSalaryReport'
export const ReportsSalary: React.FC = () => {
  const mapView = ['a', 'b', 'c']
  const tableData = [
    {
      contrato: '4501911452',
      efetivo: 3,
      he: 11.06,
      justificativaHE:
        'Horas extras devido a testes na área ( implementação de novo óleo de laminação para teste de performance com acompanhamento )',
      periodo: '07/2018',
      qtdHE: 73,
      qtdHHT: 660,
      salarioBase: 63000.0,
      totalFolha: 63000.0
    },
    {
      contrato: '4501911452',
      efetivo: 3,
      he: 11.06,
      justificativaHE:
        'Horas extras devido a testes na área ( implementação de novo óleo de laminação para teste de performance com acompanhamento )',
      periodo: '07/2018',
      qtdHE: 73,
      qtdHHT: 660,
      salarioBase: 63000.0,
      totalFolha: 63000.0
    },
    {
      contrato: '4501911452',
      efetivo: 3,
      he: 11.06,
      justificativaHE:
        'Horas extras devido a testes na área ( implementação de novo óleo de laminação para teste de performance com acompanhamento )',
      periodo: '07/2018',
      qtdHE: 73,
      qtdHHT: 660,
      salarioBase: 63000.0,
      totalFolha: 63000.0
    }
  ]
  return (
    <>
      <Card
        marginTop={SPACING.spacing20}
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <Card backgroundColor={COLORS.primary} padding="8px 0">
          <Row alignItems="center" justifyContent="center">
            <Span
              text="HHT X SALÁRIO - 08/2018"
              marginRight={SPACING.spacing50}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
            />
          </Row>
        </Card>
        {mapView?.map((contract, index) => {
          return (
            <CollapseColumn
              key={index.toString()}
              index={index}
              inicio="01/01/2016"
              fim="02/02/2017"
              nmFornecedor="Modal Gestão e Resultados"
              nmDiretoriaExecutiva="DIRETORIA EXECUTIVA PRODUÇÃO SIDERURGIA  "
              nmDiretoria="DIRETORIA DE PRODUTOS  "
              nmGerenciaGeral="GERÊNCIA GERAL LAMIN FRIO GALV DECAPAGEM"
            >
              <Row alignItems="center" justifyContent="center">
                <Span
                  text="DESCRIÇÃO DAS PENDÊNCIAS"
                  textAlign="center"
                  color={COLORS.blueFonts}
                  fontSize="24px"
                  fontWeight="700"
                />
              </Row>
              <TableSalaryReport tableData={tableData} />
            </CollapseColumn>
          )
        })}
      </Card>
    </>
  )
}
